import { ReservationModel } from "./ReservationModel";
import { UserModel } from "./UserModel";

export const InvoiceModel = {
  id: "",
  invoiceNumber: "",
  issuedDate: "",
  dueDate: "",
  status: "",
  amountDue: 0,
  totalAmountPaid: 0,
  reservationId: null,
  userId: "",
  reservation: ReservationModel,
  user: UserModel,
};
